<template>
  <div class="criterion-container">
    <div class="image-container height386-i">
      <img src="@/assets/cpbz/banner_cpbz.png" />
    </div>
    <div class="height386">
      <div class="section1 width1200">
        <img src="@/assets/cpbz/pic01.png" />
        <h1>发音-Pronunciation</h1>
        <span>
          注重学习者词汇层面的发音准确度和清晰度，掌握正确标准的英语语音，为实现准确表达思想奠定基础。
          学习者应能够顺利完成英语元音、辅音音素的读音、常见字母组合的发音、重读音节的发音、相似词汇的辨音。
        </span>
      </div>
    </div>
    <div class="height386 bgf7">
      <div class="section2 width1200">
        <img src="@/assets/cpbz/pic2.png" />
        <h1>技巧- Skill</h1>
        <span>学习者应能够熟练掌握和使用词汇在句子/语篇层面的重读、弱读不完全爆破、连读、节奏、停顿、基本语调等技巧，让语流输出自然得体;并能够通过重音、语调的变化，表达自己的观点和态度。</span>
      </div>
    </div>

    <div class="height386">
      <div class="section3 width1200">
        <img src="@/assets/cpbz/pic03.png" />
        <h1>流利性和连贯性-Fluency&Coherence</h1>
        <span>学习者在语篇朗读或头表达过程中，通过掌握英语连读、失去爆破、重读和弱读、句子重音、停顿及节奏的规律，达到语流流畅而有节奏感。避免因思维停顿和表达停顿影响整体语义的传达;在话题表达任务中，学习者应做到所表达内容前后顺序合理、收尾呼应，句与句之间保持连续性，从而提升信息传递的效率。</span>
      </div>
    </div>
    <div class="height386 bgf7">
      <div class="section4 width1200">
        <img src="@/assets/cpbz/pic4.png" />
        <h1>内容-Content</h1>
        <span>学习者在完成内容转述或话题表达任务时，应做到所转述内容或表达内容的要点完整、信息准确，同时根据原始语料或任务要求做到重点突出，主要细节详实，顺利完成信息传递或正确合理表达自己的观点和态度，并容易被其他人理解。</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="less" scoped>
.criterion-container {
  .image-container {
    background-color: #0066cc;
    text-align: center;
    img {
      margin: 0 auto;
    }
  }
  .height386-i {
    height: 386px;
    display: flex;
  }
  .height386 {
    height: 386px;
    display: flex;
    justify-content: space-around;

  }
  .width1200 {
    width: 1200px;
    margin: 0 auto;
  }
  .bgf7 {
    background-color: #f7f7f7;
  }
  .image-container {
    background-color: #0066cc;
    text-align: center;
  }
  .section1 {
    position: relative;
    h1 {
      position: absolute;
      color: #344f97;
      font-size: 38px;
      line-height: 48px;
      left: 65px;
      top: 96px;
    }
    span {
      font-size: 16px;
      line-height: 35px;
      color: #1e1e1e;
      position: absolute;
      left: 65px;
      top: 153px;
      display: block;
      width: 624px;
    }
    img {
      position: absolute;
      left: 797px;
      top: 32px;
    }
  }

  .section2 {
    position: relative;
    h1 {
      position: absolute;
      color: #344f97;
      font-size: 38px;
      line-height: 48px;
      left: 551px;
      top: 96px;
    }
    span {
      font-size: 16px;
      line-height: 35px;
      color: #1e1e1e;
      position: absolute;
      left: 551px;
      top: 151px;
      display: block;
      width: 565px;
    }
    img {
      position: absolute;
      left: 66px;
      top: 27px;
    }
  }
  .section3 {
    position: relative;
    margin: 0 auto;
    h1 {
      position: absolute;
      color: #344f97;
      font-size: 38px;
      line-height: 48px;
      left: 65px;
      top: 113px;
    }
    span {
      left: 65px;
      top: 173px;
      font-size: 16px;
      line-height: 35px;
      color: #1e1e1e;
      position: absolute;
      display: block;
      width: 625px;
    }
    img {
      position: absolute;
      left: 801px;
      top: 64px;
    }
  }
  .section4 {
    position: relative;
    h1 {
      position: absolute;
      color: #344f97;
      font-size: 38px;
      line-height: 48px;
      left: 554px;
      top: 96px;
    }
    span {
      left: 551px;
      top: 153px;
      font-size: 16px;
      line-height: 35px;
      color: #1e1e1e;
      position: absolute;
      display: block;
      width: 565px;
    }
    img {
      position: absolute;
      left: 65px;
      top: 10px;
    }
  }
}
</style>
